<template>
  <div>
    <h1 class="page-header">Exchange Rate</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create @success_create="fetchData" :edit="edit_data" @success_update="edit_data = ''"></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper class="d-flex justify-content-end">
            <ts-input v-model="search" placeholder="Search" style="width: 300px;" />
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template slot-scope="{ record }">
              <td class="kh-font">
                {{ record.currency_from ? record.currency_from.currency_name_en : '' }}
              </td>
              <td>
                {{ record.currency_to ? record.currency_to.currency_name_en : '' }}
              </td>
              <td>{{ record.fx_rate }}</td>
              <td class="text-center">
                <a href="#" title="edit" class="text-primary mr-2" @click="edit(record)">
                  <i class="fas fa-edit"></i>
                </a>
                <a href="#" title="delete" class="text-danger" @click="destroy(record.fx_id)">
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData"> </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'exchange-rate',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      columns: [
        { name: 'currency from' },
        { name: 'currency to' },
        { name: 'rate' },
        { name: 'Action', style: 'width: 1px; text-align:center' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administration/exchangeRate', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administration.exchangeRate.search
      },
      set(newVal) {
        this.$store.commit('administration/exchangeRate/SET_SEARCH', newVal)
        this.$store.commit('administration/exchangeRate/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('administration/exchangeRate/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.edit_data = data
      this.$router.push(`/exchange-rates/${data.fx_id}`)
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('administration/exchangeRate/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
